export default __webpack_public_path__ + "static/media/Saints.6ce3de84.svg";